import React from 'react'
import { Head, Link, useForm } from '@inertiajs/react'
import { Container, Typography, Box, Button, Paper, Stack, TextField } from '@mui/material'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'

interface Company {
  id: number
  name: string
  country: string | null
  website_url: string | null
  description: string | null
}

interface Props {
  company: Company
}

export default function EditCompany({ company }: Props) {
  const { data, setData, patch, processing, errors } = useForm({
    name: company.name,
    country: company.country || '',
    website_url: company.website_url || '',
    description: company.description || '',
  })

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    patch(`/companies/${company.id}`, { data: { company: data } })
  }

  return (
    <>
      <Head title={`Edit ${company.name}`} />
      <Container maxWidth="sm" sx={{ py: 5 }}>
        <Box sx={{ mb: 4 }}>
          <Button
            component={Link}
            href={`/companies/${company.id}`}
            startIcon={<ArrowBackIcon />}
            sx={{ mb: 2 }}
          >
            Back to {company.name}
          </Button>
          <Typography variant="h5">Edit {company.name}</Typography>
        </Box>

        <form onSubmit={handleSubmit}>
          <Paper sx={{ p: 4, mb: 4 }}>
            <Stack spacing={2.5}>
              <TextField
                label="Name"
                value={data.name}
                onChange={(e) => setData('name', e.target.value)}
                error={!!errors.name}
                helperText={(errors as any).name?.[0]}
                required
                fullWidth
              />
              <TextField
                label="Country"
                value={data.country}
                onChange={(e) => setData('country', e.target.value)}
                fullWidth
                placeholder="e.g. South Korea"
              />
              <TextField
                label="Website"
                value={data.website_url}
                onChange={(e) => setData('website_url', e.target.value)}
                fullWidth
                placeholder="https://..."
              />
              <TextField
                label="Description"
                value={data.description}
                onChange={(e) => setData('description', e.target.value)}
                fullWidth
                multiline
                rows={3}
              />
            </Stack>
          </Paper>

          <Button type="submit" variant="contained" disabled={processing}>
            Update Company
          </Button>
        </form>
      </Container>
    </>
  )
}
